import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useThemeFlag } from '../../../base/ThemeProvider';

import styles from './Link.module.scss';

const themes = {
  dark: 'link__dark',
  light: 'link__light',
  light_underline: 'link__light--underline',
  beige: 'link__beige'
};

const types = {
  primary: 'link__primary',
  secondary: 'link__secondary'
};

const sizes = {
  small: 'link-rebranded__small',
  medium: 'link-rebranded__medium',
  large: 'link-rebranded__large'
};

const cx = classNames.bind(styles);

const generateClassNameByProp = (prop, cn) => {
  const current = cn[prop];
  return styles[current] || '';
};

const generateClassName = (theme, hover, type) => {
  const className = styles.link;
  const themeClassName = generateClassNameByProp(theme, themes);
  const typeClassName = generateClassNameByProp(type, types);

  return cx(className, themeClassName, typeClassName, {
    [styles.link__action]: hover
  });
};

const generateLinkClassName = (hover, size, disabled, underlined) => {
  const className = styles['link-rebranded'];
  const sizeClassName = generateClassNameByProp(size, sizes);
  return cx(className, sizeClassName, {
    [styles['link-rebranded__action']]: hover,
    [styles['link-rebranded__disabled']]: disabled,
    [styles['link-rebranded__underlined']]: underlined
  });
};

const Link = ({
  children,
  theme,
  hover,
  type,
  renderIcon,
  size,
  iconClassName,
  disabled,
  underlined,
  ...rest
}) => {
  const newButtonsEnabled = useThemeFlag('newButtons');
  return newButtonsEnabled ? (
    <a
      {...rest}
      className={classNames(
        generateLinkClassName(hover, size, disabled, underlined),
        rest.className
      )}
    >
      {renderIcon && <span className={iconClassName}>{renderIcon()}</span>}
      {children}
    </a>
  ) : (
    <a
      {...rest}
      className={classNames(
        generateClassName(theme, hover, type),
        rest.className
      )}
    >
      {children}
    </a>
  );
};

Link.defaultProps = {
  theme: 'default',
  size: 'default',
  hover: true,
  type: 'primary',
  children: undefined,
  iconClassName: '',
  renderIcon: null,
  disabled: false,
  underlined: true
};

Link.propTypes = {
  theme: PropTypes.oneOf(['default', 'dark', 'light', 'light_underline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  hover: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  renderIcon: PropTypes.func,
  disabled: PropTypes.bool,
  underlined: PropTypes.bool
};

export default Link;
